import type { PropertyPaneConfig } from "constants/PropertyControlConstants";

export const propertyPaneStyleConfig: PropertyPaneConfig[] = [];
